var server = 'https://product-labels-pro.bsscommerce.com';var shopId=282;
if (typeof BSS_PL == 'undefined') {
    var BSS_PL = {};
}

var firstLoadProduct = true,
    link = document.createElement('link');
link.href = server + '/css/style.css';
link.type = 'text/css';
link.rel = 'stylesheet';
document.getElementsByTagName('head')[0].appendChild(link);

BSS_PL.init = function() {
    var listItems = $('a[href*="/products/"]:not([data-bss-pl=active]):not(.action-link)');
    if (typeof BSS_PL.configData != 'undefined' && BSS_PL.configData.length && (listItems.length || firstLoadProduct)) {
        BSS_PL.addLabel(listItems);
        firstLoadProduct = false;
    }
}

BSS_PL.getHandleByUrl = function(url) {
    if (url.indexOf('?') > 0) {
        url = url.substring(0, url.indexOf('?'));
    }
    var handle = ''
    if (url.indexOf('products') > 0) {
        var path = url.split('/');
        handle = path.pop(-1);
    }
    return handle;
}

BSS_PL.addLabel = function(listItems) {
    var handles = [];
    var handlesUrl = [];
    var path = window.location.pathname.split('/');
    var handleProductPage = path.pop(-1);
    var page = path.pop(-2);
    if (listItems.length) {
        listItems.each(function (index, item) {
            $(item).attr('data-bss-pl', 'active');
            if ($(item).closest('#slidecarthq').length || $(item).closest('#CartContainer').length ||
                $(item).closest('.social-sharing').length) {
                return;
            }
            var prodUrl = $(item).attr('href');
            var handle = BSS_PL.getHandleByUrl(prodUrl);
            if (handle) {
                if ($.inArray(handle, handles) == -1) {
                    handles.push(handle);
                    handlesUrl.push('handle:"' + decodeURIComponent(handle) + '"');
                }
                if (window.location.href.includes('/cart')) {
                    var imgElement = $(item).closest('td').find('img');
                    $(imgElement).parent().css({'position': 'relative', 'display': 'block'}).attr('data-handle', handle);
                } else {
                    if ($(item).hasClass('list-view-item') && $(item).find('.list-view-item__image-wrapper')) {
                        $(item).find('.list-view-item__image-wrapper').attr('data-handle', handle);
                    } else {
                        $(item).parent().attr('data-handle', handle);
                    }
                }
            }
        });
    }
    if (page == 'products' && $.inArray(handleProductPage, handles) == -1 && firstLoadProduct) {
        handles.push(handleProductPage);
        handlesUrl.push('handle:"' + decodeURIComponent(handleProductPage) + '"');
    }
    if ($('.index-section--featured-product:not([data-bss-pl=active])').length) {
        $('.index-section--featured-product:not([data-bss-pl=active])').each(function () {
            $(this).attr('data-bss-pl', 'active');
            var sectionId = $(this).children(':first').attr('data-section-id');
            if (sectionId) {
                var prodSection = JSON.parse($('#ProductJson-' + sectionId).html());
                if (prodSection) {
                    if ($.inArray(prodSection.handle, handles) == -1) {
                        handles.push(prodSection.handle);
                        handlesUrl.push('handle:"' + decodeURIComponent(prodSection.handle) + '"');
                    }
                    if ($(this).find('.product__photo.featured-product__photo').length) {
                        $(this).find('.product__photo.featured-product__photo').attr('data-handle', prodSection.handle);
                    } else if ($(this).find('.product-single__media').length) {
                        $(this).find('.product-single__media').attr('data-handle', prodSection.handle);
                    }
                    else {
                        $(this).find('img.product-featured-img').closest('.product-single__photo').attr('data-handle', prodSection.handle);
                    }
                }
            }
        });
    }
    if (handles.length) {
        var dataRes = BSS_PL.configData;
        var prodData = {
            baseImgUrl: server + '/images/'+ BSS_PL.storeId +'/240/'
        };

        var urlData = '/search.js?q=' + handlesUrl.join(' OR ') + '&view=bss.product.labels';

        $.get(encodeURI(urlData), function(data){
            var responProd = JSON.parse(data);
            if (responProd.length) {
                if (page == 'products') {
                    var allImages =  $('img[srcset*="/products/"][srcset*="/cdn.shopify.com/s/files/"][src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".jp\"],img[srcset*="/products/"][srcset*="/cdn.shopify.com/s/files/"][src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".JP\"],img[srcset*="/products/"][srcset*="/cdn.shopify.com/s/files/"][src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".png\"],img[srcset*="/products/"][srcset*="/cdn.shopify.com/s/files/"][src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".PNG\"],img[data-src*="/products/"][data-src*="/cdn.shopify.com/s/files/"][src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".jp\"],img[data-src*="/products/"][data-src*="/cdn.shopify.com/s/files/"][src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".JP\"],img[data-src*="/products/"][data-src*="/cdn.shopify.com/s/files/"][src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".png\"],img[data-src*="/products/"][data-src*="/cdn.shopify.com/s/files/"][src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".PNG\"]');
                    allImages.map(function (index, image) {
                        $(image).parent().attr('data-handle', handleProductPage);
                    });
                }
                responProd.map(function (item) {
                    prodData['collects'] = item.collections;
                    // prodData['isInstock'] = item.variants[0].isInstock;

                    var itemHandle = item.handle;
                    if (encodeURI(itemHandle) != itemHandle) {
                        itemHandle = encodeURI(itemHandle);
                    }
                    var parents = $('[data-handle="' + itemHandle + '"]:not(".meganav__product")');
                    var firstParent = parents[0];
                    var appended = false;
                    $.each(parents, function (index, parent) {
                        if (!$(parent).find('.bss_pl_img').length) {
                            var htmlLable = '',
                                htmlList = BSS_PL.getImageList(dataRes, item, prodData, parent);
                            if (htmlList.length) {
                                htmlLable += '<div class="bss_pl_img">';
                                htmlLable += htmlList.join('');
                                htmlLable += '</div>';
                                if ($(parent).hasClass('product-item__link-wrapper')) {
                                    if ($(parent).find('.product-item__image-container').length) {
                                        $(parent).find('.product-item__image-container').prepend(htmlLable);
                                        appended = true;
                                    } else {
                                        $(parent).find('img').wrap('<div class="product-item__image-container"></div>');
                                        $(parent).find('.product-item__image-container').prepend(htmlLable);
                                        appended = true;
                                    }
                                } else if ($(parent).find('.product-card__image-with-placeholder-wrapper').length) {
                                    $(parent).find('.product-card__image-with-placeholder-wrapper').prepend(htmlLable);
                                    appended = true;
                                } else if ($(parent).hasClass('product-single__media')) {
                                    // Fixed product slide for Debut theme
                                    if ($(parent).parent().hasClass('product-single__media-wrapper')) {
                                        $(parent).prepend(htmlLable);
                                        appended = true;
                                    }
                                } else if ($(parent).hasClass('product-single__photo')) {
                                    // Fixed product slide for Debut theme - old version
                                    if ($(parent).parent().hasClass('product-single__photo-wrapper')) {
                                        $(parent).prepend(htmlLable);
                                        appended = true;
                                    }
                                }
                                else if ($(parent).hasClass('featured-product__photo')) {
                                    //Fix for featured product on Boundless theme
                                    $(parent).prepend(htmlLable);
                                    appended = true;
                                }
                            }

                          }
                      });
                      if (!appended) {
                          var htmlLable='',
                              htmlList = BSS_PL.getImageList(dataRes, item, prodData, firstParent);
                          var isAllowInsert = !$(firstParent).hasClass('swatchProductColor');
                          if (htmlList.length && isAllowInsert) {
                              var isAbsoluteFirstParent = $(firstParent).css("position") == "absolute";
                              var isParentBelongToGallery = $(firstParent).hasClass('aspect-ratio') && $(firstParent).parent().hasClass('product-gallery__thumbnail');
                              //Fix bug
                              var isInSpareAndSquareSlides = $(firstParent).hasClass("image-slide-link") && $(".product_gallery .slides").length;
                              if (isInSpareAndSquareSlides) {
                                  firstParent = $(".product_gallery .slides");
                              }

                              var isUltramaticSleepSlides = $(".lh-big-slide .swiper-container").length;
                              if (isUltramaticSleepSlides) {
                                  firstParent = $(".lh-big-slide .swiper-container");
                              }

                              var isNobitaShop = $(firstParent).hasClass("product-single__photo-wrapper") && $(".product-single__photos.slick-slider").length;

                              if (isNobitaShop) {
                                  firstParent = $(".product-single__photos.slick-slider");
                              }

                              // End
                              if (isParentBelongToGallery) {
                                  firstParent = $('.product-gallery__carousel');
                              }

                              if (isAbsoluteFirstParent) {
                                  $(firstParent).wrapInner("<div class='bss_pl_img_wrapper' style='position:relative' />");
                              } else {
                                  $(firstParent).css("position", "relative");
                              }

                              htmlLable += '<div class="bss_pl_img">';
                              htmlLable += htmlList.join('');
                              htmlLable += '</div>';

                              if (isAbsoluteFirstParent) {
                                  $(firstParent).find('.bss_pl_img_wrapper').append(htmlLable)
                              } else {
                                  $(firstParent).prepend(htmlLable);
                              }
                          }


                      }
                    // if (itemHandle == handleProductPage) {
                    //   $.each(parents, function (index, parent) {
                    //       if (!$(parent).find('.bss_pl_img').length) {
                    //           var htmlLable = '<div class="bss_pl_img">',
                    //               htmlList = BSS_PL.getImageList(dataRes, item, prodData, parent);
                    //           htmlLable += htmlList.join('');
                    //           htmlLable += '</div>';
                    //           if ($(parent).hasClass('product-item__link-wrapper')) {
                    //               if ($(parent).find('.product-item__image-container').length) {
                    //                   $(parent).find('.product-item__image-container').prepend(htmlLable);
                    //               } else {
                    //                   $(parent).find('img').wrap('<div class="product-item__image-container"></div>');
                    //                   $(parent).find('.product-item__image-container').prepend(htmlLable);
                    //               }
                    //           } else if ($(parent).find('.product-card__image-with-placeholder-wrapper').length) {
                    //               $(parent).find('.product-card__image-with-placeholder-wrapper').prepend(htmlLable);
                    //           } else {
                    //               $(parent).css("position", "relative");
                    //               $(parent).prepend(htmlLable);
                    //           }
                    //       }
                    //   });
                    // } else {
                    //
                    //   if (!$(firstParent).find('.bss_pl_img').length) {
                    //       var htmlLable = '<div class="bss_pl_img">',
                    //           htmlList = BSS_PL.getImageList(dataRes, item, prodData, firstParent);
                    //       htmlLable += htmlList.join('');
                    //       htmlLable += '</div>';
                    //       if ($(firstParent).hasClass('product-item__link-wrapper')) {
                    //           if ($(firstParent).find('.product-item__image-container').length) {
                    //               $(firstParent).find('.product-item__image-container').prepend(htmlLable);
                    //           } else {
                    //               $(firstParent).find('img').wrap('<div class="product-item__image-container"></div>');
                    //               $(firstParent).find('.product-item__image-container').prepend(htmlLable);
                    //           }
                    //       } else if ($(firstParent).find('.product-card__image-with-placeholder-wrapper').length) {
                    //           $(firstParent).find('.product-card__image-with-placeholder-wrapper').prepend(htmlLable);
                    //       } else {
                    //           $(firstParent).css("position", "relative");
                    //           $(firstParent).prepend(htmlLable);
                    //       }
                    //   }
                    // }

                });
            }
        });
    }
}

BSS_PL.getImageList = function(data, prod, res, parent) {

    var path = window.location.pathname.split('/');
    var page = path[path.length - 2];
    var isCollectionPage = page == "collections";
    var isProductPage = page == "products";
    var isOtherPages = !isCollectionPage && !isProductPage;

    var htmlList = [];
    var filterPriority = [];
    $.each(data, function (index, item) {
        if (item.pages) {
            var activePages = item.pages.split(",");
            var isActive = (activePages.indexOf("1") >= 0 && isProductPage)
                || (activePages.indexOf("2") >= 0 && isCollectionPage)
                || (activePages.indexOf("3") >= 0 && isOtherPages);
            if (isActive) {
                if (item.img_url) {
                    // var isActive = false;

                    // if (item.inventory) {
                    //     if (!item.apply) {
                    //         if ((item.inventory == 1 && !res.isInstock) || (item.inventory == 2 && res.isInstock)) {
                    //             return;
                    //         }
                    //     } else {
                    //         if ((item.inventory == 1 && res.isInstock) || (item.inventory == 2 && !res.isInstock)) {
                    //             isActive = true;
                    //         }
                    //     }
                    // } else {
                    //     if (item.apply) {
                    //         isActive = true;
                    //     }
                    // }

                    // var isActiveFromPrice = false;
                    // if (item.from_price == null) {
                    //     if (item.apply) {
                    //         isActiveFromPrice = true;
                    //     }
                    // } else {
                    //     var fromPrice = parseFloat(item.from_price) * 100;
                    //     if (prod.price < fromPrice || prod.price_min < fromPrice) {
                    //         if (!item.apply) {
                    //             return;
                    //         }
                    //     } else {
                    //         if (item.apply) {
                    //             isActiveFromPrice = true;
                    //         }
                    //     }
                    // }
                    // var isActiveToPrice = false;
                    // if (item.to_price == null) {
                    //     if (item.apply) {
                    //         isActiveToPrice = true;
                    //     }
                    // } else {
                    //     var toPrice = parseFloat(item.to_price) * 100;
                    //     if (prod.price > toPrice || prod.price_max > toPrice) {
                    //         if (!item.apply) {
                    //             return;
                    //         }
                    //     } else {
                    //         if (item.apply) {
                    //             isActiveToPrice = true;
                    //         }
                    //     }
                    // }
                    // if (isActiveToPrice && isActiveFromPrice && item.apply) {
                    //     isActive = true;
                    // }

                    if (item.product_type == 1) {
                        if (item.collection && res.collects && res.collects.length) {
                            var collections = item.collection.split(',');
                            var prodCol = res.collects.filter(function (item) {
                                return $.inArray(item.toString(), collections) !== -1;
                            });
                            // if (!item.apply) {
                            if (!prodCol.length) {
                                return;
                            }
                            // } else {
                            //     if (prodCol.length) {
                            //         isActive = true;
                            //     }
                            // }
                        } else {
                            return;
                        }// else {
                        // isActive = true;
                        // }
                    } else if (item.product_type == 2) {
                        if (item.tags) {
                            var tags = item.tags.split(',');
                            var prodTags = prod.tags;
                            if (tags.length) {
                                if (prodTags.length) {
                                    var eqTags = tags.filter(function (tag) {
                                        return prodTags.indexOf(tag) !== -1
                                    });
                                    if (!eqTags.length) {
                                        return;
                                        // if (item.apply) {
                                        //     isActive = true;
                                        // }
                                    }// else {
                                    //     if (!item.apply) {
                                    //         return;
                                    //     }
                                    // }
                                } else {
                                    return;
                                }
                            } else {
                                return;
                            }// else {
                            //     if (!item.apply) {
                            //         return;
                            //     }
                            // }
                        } else {
                            return
                        }// else {
                        // isActive = true;
                        // }
                    } else if (item.product_type == 3) {
                        //Don't need to filter any item, apply to all product
                    } else {
                        if (item.product) {
                            var productIds = item.product.split(',');
                            if ($.inArray(prod.id.toString(), productIds) == -1) {
                                // if (!item.apply) { //AND
                                return;
                                // }
                            }
                            //  else {
                            //     if (item.apply) {
                            //         isActive = true;
                            //     }
                            // }
                        } else {
                            return;
                        }
                        //  else {
                        //     isActive = true;
                        // }
                    }

                    // if ((item.apply && isActive) || !item.apply) {
                    if (item.priority || item.priority == 0) {
                        if (typeof filterPriority[item.position] != "undefined" && filterPriority[item.position] < item.priority) {
                            return;
                        }
                        filterPriority[item.position] = item.priority;
                    }
                    var className = 'bss-pl-top-left';
                    var styleName = '';
                    switch (item.position) {
                        case 1 :
                            className = 'bss-pl-top-center';
                            break;
                        case 2 :
                            className = 'bss-pl-top-right';
                            break;
                        case 3 :
                            className = 'bss-pl-middle-left';
                            break;
                        case 4 :
                            className = 'bss-pl-middle-center';
                            break;
                        case 5 :
                            className = 'bss-pl-middle-right';
                            break;
                        case 6 :
                            className = 'bss-pl-bottom-left';
                            break;
                        case 7 :
                            className = 'bss-pl-bottom-center';
                            break;
                        case 8 :
                            className = 'bss-pl-bottom-right';
                            break;
                    }

                    if ($(parent).hasClass('hide')) {
                        $(parent).addClass('hide-clone').removeClass('hide')
                    }
                    // let parentProdH = $(parent).outerHeight();
                    // let imgProdH = $(parent).find('img').outerHeight();
                    var parentProdW = $(parent).outerWidth();
                    var imgProdW = $(parent).find('img').outerWidth();
                    if ($(parent).hasClass('hide-clone')) {
                        $(parent).addClass('hide').removeClass('hide-clone')
                    }
                    styleName += BSS_PL.resizeImage(item, parent);
                    // if ($.inArray(item.position, [3, 4, 5, 6, 7, 8]) !== -1) {
                    //  styleName += 'bottom: ';
                    //  styleName += parseFloat(parentProdH) - parseFloat(imgProdH);
                    //  styleName += 'px;';
                    // }
                    if ($.inArray(item.position, [1, 2, 4, 5, 7, 8]) !== -1) {
                        styleName += 'right: ';
                        if ($(parent).hasClass('product-card--list')) {
                            styleName += parseFloat(parentProdW) - parseFloat(imgProdW);
                        } else if ($(parent).hasClass('cart__image-wrapper')) {
                            styleName += parseFloat(parentProdW) - parseFloat($(parent).width());
                        } else if ($(parent).hasClass('featured-product__photo')) {
                            styleName += 0;
                        } else {
                            //styleName += parseFloat(parentProdW) - parseFloat($(parent).parent().width());
                            styleName += 0;
                        }
                        styleName += 'px;';
                    }
                    var imgUrl = res.baseImgUrl + item.img_url;
                    if (item.public_img_url) {
                        imgUrl = item.public_img_url;
                    }
                    var imgTag = '<img src="' + imgUrl + '" alt="' + item.name + '" class="bss-pl-frontend ' + className + '" style="' + styleName + '; position: absolute !important;" />';
                    htmlList[item.position] = imgTag;
                    // }
                }
            }
        }
    });
    return htmlList;
};

BSS_PL.resizeImage = function(item, parent) {
    var styleHtml = '';
    var suffix = 'px;';
    var itemWidth = item.width;
    var itemHeight = item.height;
    if (item.fixed_percent) {
        suffix = '%;';
        if (itemWidth > 100) {
            itemWidth = 100;
        }
        if (itemHeight > 100) {
            itemHeight = 100;
        }
    }
    if (itemWidth || itemWidth == 0) {
        styleHtml += 'max-width:';
        styleHtml += itemWidth;
        styleHtml += suffix;
    }
    if (itemHeight || itemHeight == 0) {
        styleHtml += 'max-height:';
        styleHtml += itemHeight;
        styleHtml += suffix;
    }
    return styleHtml;
}

setTimeout(function(){
    jQuery(document).ready(function () {
      jQuery.get(server + "/verifyshop/" + shopId + ".json", function(data, status){
          if (data == true) {
             BSS_PL.init();
          }
      });
    });
    jQuery(window).scroll(function() {
      jQuery.get(server + "/verifyshop/" + shopId + ".json", function(data, status){
          if (data == true) {
             BSS_PL.init();
          }
      });

    });
}, 700);
